// Material UI v1.4.0 has issue between <Card> and <Autocomplete> components
// <Autocomplete> gets cut by <Card> container because of `overflow:hidden` set.
//  https://github.com/mui-org/material-ui/pull/10946
//  https://github.com/mui-org/material-ui/pull/11572
//  https://github.com/mui-org/material-ui/issues/2623
// Below mitigate this issue

import styled from 'styled-components';

export const StyledPage = styled.div`
    width: 90%;
    max-width: 1257px;
    margin-left: auto;
    margin-right: auto;
`;
